import type { VendorPersonType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import VendorPersonsTableRow from './VendorPersonsTableRow';

interface VendorPersonsTableBodyProps {
    rows: VendorPersonType[];
    onEdit: (row: VendorPersonType) => void;
    onDelete: (row: VendorPersonType) => void;
    onOpenContacts: (row: VendorPersonType) => void;
}

const VendorPersonsTableBody = ({
    rows,
    onEdit,
    onDelete,
    onOpenContacts,
}: VendorPersonsTableBodyProps) => (
    <tbody>
        {!rows.length ? (
            <TableEmptyRow colSpan={3} />
        ) : (
            rows.map((row) => (
                <VendorPersonsTableRow
                    key={row.ID}
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onOpenContacts={onOpenContacts}
                />
            ))
        )}
    </tbody>
);

export default VendorPersonsTableBody;
